<button type="button" class="btn btn-primary btn-md" (click)="onClick()"><i class="material-icons">search</i></button>
